import {
  IButton,
  IButtonFields,
  IContextualButton,
} from '../../../types/@types/generated/contentful';
import getLinkHref from './getLinkHref';

function isIButton(button?: IButton | IContextualButton): button is IButton {
  return button?.sys.contentType.sys.id === 'button';
}

function isIContextualButton(button?: IButton | IContextualButton): button is IContextualButton {
  return button?.sys.contentType.sys.id === 'contextualButton';
}

const buttonToCompatibleProps = ({
  button,
  settings,
}: {
  button?: IButton | IContextualButton;
  settings?: Record<string, unknown>;
}) => {
  if (isIButton(button)) {
    return {
      label: button.fields.label,
      prompt: button.fields.prompt,
      href: getLinkHref(button.fields.link) || button.fields.href,
      colorContext: button.fields.colorContext,
      size: button.fields.size,
      variant: button.fields.variant,
      trailingIconName: button.fields.trailingIconName,
      leadingIconName: button.fields?.leadingIconName,
    };
  } else if (isIContextualButton(button)) {
    return {
      label: button.fields.label,
      prompt: button.fields.prompt,
      href: getLinkHref(button.fields.link),
    };
  } else {
    const settingsButton = {
      label: (settings?.CTAText || settings?.buttonLabel) as string | undefined,
      prompt: settings?.CTAPrompt as string | undefined,
      href: settings?.href as string | undefined,
      colorContext: (settings?.buttonColor || settings?.CTAColor) as
        | IButtonFields['colorContext']
        | undefined,
      size: (settings?.buttonLarge || 'large') as IButtonFields['size'] | undefined,
      variant: undefined,
      trailingIconName: undefined,
      leadingIconName: undefined,
    };
    if (settingsButton.label) {
      return settingsButton;
    }
    return;
  }
};

export default buttonToCompatibleProps;
